import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getImportRequest } from './store/selectors';

export function NewImportBackToMappingModal({
  importRequest,
  onClose,
  shown
}) {
  const history = useHistory();

  const onBackToUploadForm = (e) => {
    e.stopPropagation();
    history.push(`/${importRequest.id}/mapping`);
  };

  const onCancel = () => {
    onClose(false);
  };

  return (
    <Modal show={shown} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Unsaved changes</Modal.Title>
      </Modal.Header>
      <Modal.Body className="left-buffer-md">
        <div className="top-buffer-sm">
          Are you sure you want to go back?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-sm btn-cancel" type="button" onClick={onCancel}>Cancel</button>
        <button className="btn btn-sm btn-save" type="button" onClick={onBackToUploadForm}>
          Back to mapping
        </button>
      </Modal.Footer>
    </Modal>
  );
}

NewImportBackToMappingModal.propTypes = {
  importRequest: PropTypes.object.isRequired,
  shown: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  importRequest: getImportRequest(state)
});

export default connect(mapStateToProps, null)(NewImportBackToMappingModal);
